import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import TreatmentGallery from '../components/TreatmentGallery';
import TreatmentFAQ from '../components/TreatmentFAQ';
import { imageUrl } from '../lib/images';

export default function BehandlingstyperPage() {
  const bookingUrl = 'https://djursmassage.app4.geckobooking.dk/site/booking.php?show=new_booking&icCode=69a506a6f06a0ca7022b880e8f6bcb65b11332&bId=11332&aDIfH=1&dTpl=1&sSToken=267bea05a53684a4a7d7ad2e6bae564a';

  return (
    <>
      <SEOHead
        title="Behandlingstyper & Metoder | Djurs Massage"
        description="Læs om fysiurgisk massage, cupping, øreakupunktur, EMS, scraping og kinesiotape hos Djurs Massage i Ryomgård. Målrettet smertelindring. Book tid."
        ogImage="https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/djurs-massage-klinik-ryomgaard.jpg"
      />

      {/* Clean page header - NO container box, NO paragraph above heading */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-6">
        <div className="max-w-3xl">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1E3A5F] font-serif leading-tight">
            Forskellige behandlingstyper
          </h1>
          <div className="text-slate-700 text-sm sm:text-base mt-3 leading-relaxed space-y-2">
            <p>
              Når du har brug for effektiv og varig lindring af dine smerter, vil jeg hver gang tage udgangspunkt i din unikke og aktuelle her og nu situation for at sikre den bedst mulige behandling.
            </p>
            <p>
              Jeg vil altid med udgangspunkt i Fysiurgisk Massage vurdere dine behov og benytte mig af en eller flere af nedenstående teknikker for at opnå den mest optimale og skræddersyede behandling til dig.
            </p>
          </div>
          <div className="mt-5 flex flex-wrap items-center gap-3">
            <a
              href={bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 sm:px-6 sm:py-2.5 bg-[#1E3A5F] text-white text-xs sm:text-sm font-semibold rounded-full hover:shadow-md transition-shadow"
            >
              <i className="fa-solid fa-calendar-check text-[#C9A770]" aria-hidden="true" />
              <span>Book tid</span>
            </a>
            {/* Secondary CTA: strictly NO background color and NO hover background color */}
            <Link
              to="/prisliste"
              className="inline-flex items-center gap-2 px-4 py-2 sm:px-6 sm:py-2.5 bg-transparent hover:bg-transparent text-[#1E3A5F] hover:text-black border border-[#1E3A5F] text-xs sm:text-sm font-semibold rounded-full transition-colors"
            >
              <span>Gå til prisliste</span>
              <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </div>

      {/* Varigheder & Priser Overview */}
      <div className="border-y border-[#E8E1D5] bg-white py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row sm:items-baseline justify-between gap-2 mb-4">
            <h2 className="text-lg sm:text-xl font-bold text-[#1E3A5F] font-serif">
              Massage 30-90 minutter / Zoneterapi 60 minutter / Relax-massage 30/60 minutter
            </h2>
            <span className="text-sm font-bold text-[#1E3A5F] shrink-0">
              Priser starter fra 300 kr. (zoneterapi fra 600 kr.) · Rabat ved klippekort
            </span>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 text-xs sm:text-sm text-slate-700">
            <div className="border-l-2 border-[#1E3A5F] pl-3 py-1">
              <div className="flex items-baseline justify-between">
                <strong className="text-[#1E3A5F] block">30 minutter</strong>
                <span className="font-bold text-[#1E3A5F]">300 kr.</span>
              </div>
              <p className="text-slate-600 mt-1">F.eks. vedligeholdelse eller fokuseret behandling af ryg/nakke.</p>
            </div>
            <div className="border-l-2 border-[#1E3A5F] pl-3 py-1">
              <div className="flex items-baseline justify-between">
                <strong className="text-[#1E3A5F] block">45 minutter</strong>
                <span className="font-bold text-[#1E3A5F]">450 kr.</span>
              </div>
              <p className="text-slate-600 mt-1">Anbefales til mindre kropsområder, som f.eks. ryg-/nakkemassage.</p>
            </div>
            <div className="border-l-2 border-[#1E3A5F] pl-3 py-1">
              <div className="flex items-baseline justify-between">
                <strong className="text-[#1E3A5F] block">60 minutter</strong>
                <span className="font-bold text-[#1E3A5F]">600 kr.</span>
              </div>
              <p className="text-slate-600 mt-1">Grundig, dybere ryg-/nakkemassage eller afslappende kropsmassage.</p>
            </div>
            <div className="border-l-2 border-[#1E3A5F] pl-3 py-1">
              <div className="flex items-baseline justify-between">
                <strong className="text-[#1E3A5F] block">90 minutter</strong>
                <span className="font-bold text-[#1E3A5F]">900 kr.</span>
              </div>
              <p className="text-slate-600 mt-1">Komplet dybdegående helkropsmassage tilpasset dine behov.</p>
            </div>
          </div>
        </div>
      </div>

      {/* In-depth Technique Sections directly on page - NO box wrappers */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 divide-y divide-[#E8E1D5]">
        {/* 1. Fysiurgisk massage */}
        <section className="py-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7 space-y-3">
            <h2 className="text-xl sm:text-2xl font-bold text-[#1E3A5F] font-serif">Fysiurgisk massage & Sportsmassage (RAB-godkendt)</h2>
            <div className="inline-block bg-[#F8F5EF] border border-[#C9A770]/40 px-3 py-1 text-xs font-semibold text-[#1E3A5F] rounded">
              RAB-godkendt massør · Eneste officielle kvalitetsstempel for massører i Danmark · Falck Healthcare & AP Pension godkendt
            </div>
            <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
              Fysiurgisk massage er en dybdegående massageform, der tager udgangspunkt i kroppens anatomi og fysiologi. Den fokuserer på at løsne spændinger i muskler og sener samt stimulere blodcirkulationen. Det kan give effektiv smertelindring i leddene, da muskler og sener slipper deres spænding og dermed ikke længere trækker i leddene. Tine er RAB-godkendt massør, hvilket er sundhedsforsikringers krav for at dække massage.
            </p>
            <div className="space-y-1 text-xs sm:text-sm text-slate-700 pt-1">
              <div className="font-bold text-[#1E3A5F]">Gavnlige effekter:</div>
              <p>• Løsning af muskel- og senespændinger: Hjælper med at afspænde vævet og reducere ømhed.</p>
              <p>• Øget blodcirkulation: Forbedrer ilt- og næringsstoftilførslen og hjælper med at fjerne affaldsstoffer.</p>
              <p>• Smertelindring i led: Lindrer ledsmerter, da muskler og sener slipper deres træk i leddene. Her er EMS-dragt (KUN dragt, 300 kr./30 min, ingen træning) også enormt effektiv, da den aktiverer kroppens egne smertehæmmende stoffer.</p>
              <p>• Forbedret mobilitet: Løsner muskler og sener, hvilket giver bedre bevægelighed, da det ikke længere trækker i leddene.</p>
              <p>• Stressreduktion: Har en afslappende effekt og kan reducere stressniveauet.</p>
            </div>
            <div className="pt-2">
              <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-2 bg-[#1E3A5F] text-white text-xs font-semibold rounded-full hover:shadow-md transition-shadow">
                <span>Book tid</span>
              </a>
            </div>
          </div>
          <div className="lg:col-span-5 aspect-4/3 overflow-hidden border border-[#E8E1D5] bg-[#E8E1D5]">
            <img src={imageUrl('https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/fysiurgisk-massage-rygbehandling.jpg', 'width=800,height=600,fit=cover,quality=85,format=auto')} alt="Fysiurgisk massage" className="w-full h-full object-cover" />
          </div>
        </section>

        {/* 2. Cupping massage */}
        <section className="py-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7 space-y-3">
            <h2 className="text-xl sm:text-2xl font-bold text-[#1E3A5F] font-serif">Cupping massage</h2>
            <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
              Cuppingmassage er en behandlingsform, hvor vakuumkopper anvendes til at skabe undertryk på huden for at øge blodcirkulationen, løsne spændinger og stimulere kroppens naturlige helingsproces. Behandlingen tilpasses så den <strong>ikke giver store blå mærker</strong>, og den har en særdeles <strong>god effekt ved cellulitis / appelsinhud</strong>.
            </p>
            <div className="space-y-1 text-xs sm:text-sm text-slate-700 pt-1">
              <div className="font-bold text-[#1E3A5F]">Cuppingmassage bruges ofte til:</div>
              <p>• Muskelspændinger og myoser (fx nakke, skuldre, ryg)</p>
              <p>• Stress og træthed – virker afslappende på nervesystemet</p>
              <p>• Gigt og ledsmerter – kan reducere inflammation</p>
              <p>• Arvæv og stramt bindevæv – forbedrer vævets elasticitet</p>
              <p>• Cellulite og hudforbedring – øger blodgennemstrømningen i huden</p>
            </div>
            <div className="pt-2">
              <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-2 bg-[#1E3A5F] text-white text-xs font-semibold rounded-full hover:shadow-md transition-shadow">
                <span>Book tid</span>
              </a>
            </div>
          </div>
          <div className="lg:col-span-5 aspect-4/3 overflow-hidden border border-[#E8E1D5] bg-[#E8E1D5]">
            <img src={imageUrl('https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/cupping-massage-vakuum-behandling.jpg', 'width=800,height=600,fit=cover,quality=85,format=auto')} alt="Cupping massage" className="w-full h-full object-cover" />
          </div>
        </section>

        {/* 3. 5 punkts øreakupunktur */}
        <section className="py-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7 space-y-3">
            <h2 className="text-xl sm:text-2xl font-bold text-[#1E3A5F] font-serif">5 punkts øreakupunktur</h2>
            <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
              5-punkts øreakupunktur er en særlig form for øreakupunktur, hvor fem specifikke punkter i øret stimuleres med nåle. Metoden anvendes ofte til stresshåndtering, afvænning, smertelindring og mental balance.
            </p>
            <div className="space-y-1 text-xs sm:text-sm text-slate-700 pt-1">
              <div className="font-bold text-[#1E3A5F]">Bruges ofte til:</div>
              <p>• Stress, angst og depression</p>
              <p>• Afhængighedsbehandling (alkohol, nikotin, narkotika)</p>
              <p>• Søvnproblemer og uro</p>
              <p>• Smerter og spændinger</p>
              <p>• Emotionel balance og mental klarhed</p>
            </div>
            <div className="pt-2">
              <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-2 bg-[#1E3A5F] text-white text-xs font-semibold rounded-full hover:shadow-md transition-shadow">
                <span>Book tid</span>
              </a>
            </div>
          </div>
          <div className="lg:col-span-5 aspect-4/3 overflow-hidden border border-[#E8E1D5] bg-[#E8E1D5]">
            <img src={imageUrl('https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/oereakupunktur-5-punkts-behandling.jpg', 'width=800,height=600,fit=cover,quality=85,format=auto')} alt="5 punkts øreakupunktur" className="w-full h-full object-cover" />
          </div>
        </section>

        {/* 4. Laser- / ultralydsbehandling */}
        <section className="py-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7 space-y-3">
            <h2 className="text-xl sm:text-2xl font-bold text-[#1E3A5F] font-serif">Laser-/ultralydsbehandling</h2>
            <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
              Laser- og ultralydsbehandling er begge teknikker, der bruges til at fremme heling, lindre smerte og reducere inflammation.
            </p>
            <div className="space-y-1 text-xs sm:text-sm text-slate-700 pt-1">
              <div className="font-bold text-[#1E3A5F]">Fordele:</div>
              <p>• Ikke-invasiv og smertefri</p>
              <p>• Kan bruges til at behandle både akut og kronisk smerte</p>
              <p>• Ingen kendte bivirkninger ved korrekt brug</p>
              <div className="font-bold text-[#1E3A5F] pt-2">Forskelle:</div>
              <p>• <strong>Laserbehandling:</strong> Bruger lysenergi til at stimulere celler, fremme heling og reducere inflammation.</p>
              <p>• <strong>Ultralydsbehandling:</strong> Bruger lydbølger til at fremme mikrosirkulationen og lindre dybere vævsskader, såsom muskel- og seneskader.</p>
            </div>
            <div className="pt-2">
              <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-2 bg-[#1E3A5F] text-white text-xs font-semibold rounded-full hover:shadow-md transition-shadow">
                <span>Book tid</span>
              </a>
            </div>
          </div>
          <div className="lg:col-span-5 aspect-4/3 overflow-hidden border border-[#E8E1D5] bg-[#E8E1D5]">
            <img src={imageUrl('https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/ultralyd-laser-behandling-muskler.jpg', 'width=800,height=600,fit=cover,quality=85,format=auto')} alt="Laser og ultralydsbehandling" className="w-full h-full object-cover" />
          </div>
        </section>

        {/* 5. Scraping */}
        <section className="py-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7 space-y-3">
            <h2 className="text-xl sm:text-2xl font-bold text-[#1E3A5F] font-serif">Scraping (Gua Sha)</h2>
            <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
              Scraping løsner bindevæv og øger blodcirkulationen markant – ligesom gua sha, som mange kender fra ansigtsbehandling og ansigtsløft. Behandlingen bruges som et effektivt supplement til massage.
            </p>
            <div className="space-y-1 text-xs sm:text-sm text-slate-700 pt-1">
              <div className="font-bold text-[#1E3A5F]">Effekter af scraping:</div>
              <p>• Øger blodcirkulationen – fremmer tilførslen af næringsstoffer og ilt til vævet</p>
              <p>• Reducerer muskelspændinger – løsner stive og ømme områder</p>
              <p>• Stimulerer lymfedrænage – hjælper kroppen med at udskille affaldsstoffer</p>
              <p>• Nedbryder arvæv og fascierestriktioner – forbedrer bevægeligheden</p>
              <p>• Smertelindring – dæmper inflammation og muskelømhed</p>
            </div>
            <div className="pt-2">
              <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-2 bg-[#1E3A5F] text-white text-xs font-semibold rounded-full hover:shadow-md transition-shadow">
                <span>Book tid</span>
              </a>
            </div>
          </div>
          <div className="lg:col-span-5 aspect-4/3 overflow-hidden border border-[#E8E1D5] bg-[#E8E1D5]">
            <img src={imageUrl('https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/scraping-behandling-bindevaev.jpg', 'width=800,height=600,fit=cover,quality=85,format=auto')} alt="Scraping behandling" className="w-full h-full object-cover" />
          </div>
        </section>

        {/* 6. Lymfedrænage */}
        <section className="py-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7 space-y-3">
            <h2 className="text-xl sm:text-2xl font-bold text-[#1E3A5F] font-serif">Lymfedrænage</h2>
            <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
              Lymfedrænage handler om at hjælpe kroppen med at få fjernet affaldsstoffer og ekstra væske, der samler sig i kroppen. Nogle gange kan lymfesystemet få problemer, og væsken kan samle sig i steder som arme eller ben, hvilket kan få dem til at hæve op og blive tunge. Lymfedrænage er en teknik, hvor jeg bruger let massage til at hjælpe lymfesystemet med at arbejde bedre og få væsken væk fra de steder, hvor den ikke skal være.
            </p>
            <div className="pt-2">
              <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-2 bg-[#1E3A5F] text-white text-xs font-semibold rounded-full hover:shadow-md transition-shadow">
                <span>Book tid</span>
              </a>
            </div>
          </div>
          <div className="lg:col-span-5 aspect-4/3 overflow-hidden border border-[#E8E1D5] bg-[#E8E1D5]">
            <img src={imageUrl('https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/lymfedraenage-massage-behandling.jpg', 'width=800,height=600,fit=cover,quality=85,format=auto')} alt="Lymfedrænage" className="w-full h-full object-cover" />
          </div>
        </section>

        {/* 7. Kinesio taping */}
        <section className="py-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7 space-y-3">
            <h2 className="text-xl sm:text-2xl font-bold text-[#1E3A5F] font-serif">Kinesio taping</h2>
            <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
              Kinesio taping er en metode, hvor elastisk sportstape bruges til at støtte muskler og led uden at begrænse bevægeligheden. Kinesio tape påføres huden i forskellige mønstre afhængigt af den ønskede effekt.
            </p>
            <div className="space-y-1 text-xs sm:text-sm text-slate-700 pt-1">
              <p>• Smertelindring: Reducerer belastningen på muskler og led ved at påvirke proprioceptionen.</p>
              <p>• Støtte og stabilitet: Hjælper med at aktivere eller aflaste muskler uden at begrænse bevægelsesfriheden.</p>
              <p>• Øget blodcirkulation og lymfeflow: Kan reducere hævelse og inflammation.</p>
              <p>• Forbedret muskelaktivering: Giver ekstra sensorisk stimulering for at aktivere eller hæmme muskler.</p>
            </div>
            <div className="pt-2">
              <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-2 bg-[#1E3A5F] text-white text-xs font-semibold rounded-full hover:shadow-md transition-shadow">
                <span>Book tid</span>
              </a>
            </div>
          </div>
          <div className="lg:col-span-5 aspect-4/3 overflow-hidden border border-[#E8E1D5] bg-[#E8E1D5]">
            <img src={imageUrl('https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/kinesiologitape-nakke-behandling.jpeg', 'width=800,height=600,fit=cover,quality=85,format=auto')} alt="Kinesio taping" className="w-full h-full object-cover" />
          </div>
        </section>

        {/* 8. Dry needling */}
        <section className="py-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7 space-y-3">
            <h2 className="text-xl sm:text-2xl font-bold text-[#1E3A5F] font-serif">Dry needling</h2>
            <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
              Dry needling løsner muskelspændinger, bl.a. ved hjælp af nervestimuli i musklen. Behandlingen involverer brugen af meget tynde akupunkturnåle, der indsættes direkte i muskulære triggerpunkter (myoser eller spændingsknuder).
            </p>
            <p className="text-slate-700 text-xs sm:text-sm leading-relaxed">
              Det er baseret på vestlig medicinsk anatomi og fysiologi, og har som mål at løsne spændte muskler, forbedre blodcirkulationen og stimulere kroppens naturlige helingsproces.
            </p>
            <div className="pt-2">
              <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-2 bg-[#1E3A5F] text-white text-xs font-semibold rounded-full hover:shadow-md transition-shadow">
                <span>Book tid</span>
              </a>
            </div>
          </div>
          <div className="lg:col-span-5 aspect-4/3 overflow-hidden border border-[#E8E1D5] bg-[#E8E1D5]">
            <img src={imageUrl('https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/dry-needling-akupunkturnaale-djurs-massage.jpeg', 'width=800,height=600,fit=cover,quality=85,format=auto')} alt="Dry needling" className="w-full h-full object-cover" />
          </div>
        </section>

        {/* 9. Zoneterapi */}
        <section className="py-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7 space-y-3">
            <h2 className="text-xl sm:text-2xl font-bold text-[#1E3A5F] font-serif">Zoneterapi (voksne & babyer)</h2>
            <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
              Zoneterapi er en naturlig reflekszonebehandling under og på fødderne. Hver reflekszone hænger sammen med organer, muskler og væv i resten af kroppen. Ved at stimulere disse reflekszoner hjælpes kroppen til at genoprette balance og stimulere selvhelbredende processer. Sophie tilbyder desuden også nænsom zoneterapi til babyer.
            </p>
            <div className="space-y-1 text-xs sm:text-sm text-slate-700 pt-1">
              <div className="font-bold text-[#1E3A5F]">Hvad kan zoneterapi hjælpe med?</div>
              <p>✨ Stress, uro og søvnproblemer</p>
              <p>✨ Hovedpine og migræne</p>
              <p>✨ Spændinger i nakke, skuldre og ryg</p>
              <p>✨ Fordøjelsesproblemer og hormonelle ubalancer</p>
            </div>
            <div className="pt-2">
              <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-2 bg-[#1E3A5F] text-white text-xs font-semibold rounded-full hover:shadow-md transition-shadow">
                <span>Book tid</span>
              </a>
            </div>
          </div>
          <div className="lg:col-span-5 aspect-4/3 overflow-hidden border border-[#E8E1D5] bg-[#E8E1D5]">
            <img src={imageUrl('https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/pedicure-fodmassage-zoneterapi-behandling.jpeg', 'width=800,height=600,fit=cover,quality=85,format=auto')} alt="Zoneterapi reflekspunkter" className="w-full h-full object-cover" />
          </div>
        </section>

        {/* 10. Relax massage */}
        <section className="py-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7 space-y-3">
            <h2 className="text-xl sm:text-2xl font-bold text-[#1E3A5F] font-serif">Relax Massage ved Diana</h2>
            <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
              Relax Massage er en rolig og afslappende massage med fokus på velvære, ro og afspænding. Udføres af Diana, som er uddannet kosmetolog i Spanien.
            </p>
            <div className="space-y-1 text-xs sm:text-sm text-slate-700 pt-1">
              <p>• <strong>Relax Massage – 30 minutter:</strong> Fokus på ryg, nakke og skuldre.</p>
              <p>• <strong>Relax Massage – 60 minutter:</strong> Afslappende kropsmassage for dyb ro.</p>
              <p>• <strong>Tilkøb:</strong> Hovedbunds- og ansigtsmassage (+150 kr.).</p>
            </div>
            <div className="pt-2">
              <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-2 bg-[#1E3A5F] text-white text-xs font-semibold rounded-full hover:shadow-md transition-shadow">
                <span>Book tid</span>
              </a>
            </div>
          </div>
          <div className="lg:col-span-5 aspect-4/3 overflow-hidden border border-[#E8E1D5] bg-[#E8E1D5]">
            <img src={imageUrl('https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/relax-massage-afslappende-rygmassage.png', 'width=800,height=600,fit=cover,quality=85,format=auto')} alt="Relax massage ved Diana" className="w-full h-full object-cover" />
          </div>
        </section>

        {/* FAQ Section */}
        <div className="pt-8">
          <TreatmentFAQ treatmentSlug="behandlingstyper" />
        </div>
      </div>
    </>
  );
}
